export const USER_API_ROUTES = {
  GET_SELF_PROFILE: '/customers/profile',
  UPDATE_SELF_PROFILE: '/customers/profile',
};
